<div class="header" [ngStyle]="{ 'border-bottom-color': theme.primaryColor }">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-sm-auto">
        <a class="navbar-brand" (click)="goToJobsPage()">
          <img src="{{theme.logoUri}}" class="logo">
        </a>
      </div>
      <div class="col-12 col-sm text-center text-sm-right">
        <form class="searchForm waves-light" [class.hide]="isMobile && expand" mdbWavesEffect>
          <div class="md-form">
            <input class="form-control mr-sm-2" type="text" placeholder="Search ..." name="search" [(ngModel)]="search">
          </div>          
          <button class="btn btn-primary" (click)="fetchData()"><i class="fa fa-search"></i> <span>Find Jobs</span></button>
        </form>
      </div>
    </div>  
  </div>
</div>
<div class="pageWrapper">
  <div class="container mt-3">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5 col-9 sidebar expanded" [class.mobileSidebar]="isMobile && expand === true" [class.expanded]="expand === true">
        <ng-container>
          <div [class.mobileFilterMenu]="isMobile">
            <div *ngIf="model.facets.length > 1 && !isMobile" class="box">
              <a class="clearFilter" (click)="clearAllFacetFilters()"><i class="fa fa-filter"></i> Clear All Filters</a>
            </div>
            <div *ngIf="isMobile">
              <button type="button" class="close pull-right" aria-label="Close" (click)="expand=!expand">
                <span aria-hidden="true" class="mobileCloseButton">×</span>
              </button>
              
              <br />
            </div>
            <div class="box mt-4" [class.mt-4]="!isMobile" [class.mobileFilterSection]="isMobile" *ngFor="let facet of model.facets">
              <div class="filterGroup">
                <div>
                  <span class="float-right"><a class="clearFilter" (click)="clearFacetFilters(facet)">Clear</a></span>
                  <h3>{{getFacetDisplayName(facet)}}</h3>
                </div>
                <ul>
                  <li *ngFor="let facetResult of (facet.isExpanded ? facet.results : (facet.results | slice:0:5))">
                    <mdb-checkbox id="{{facet.name}}{{facetResult.value}}"
                                  name="{{facet.name}}{{facetResult.value}}"
                                  [(ngModel)]="facetResult.isSelected"
                                  class="form-check-input"
                                  (ngModelChange)="onFacetFilterChange()"
                                  mdbInput
                                  data-success=" "></mdb-checkbox>
                    <label class="form-check-label" for="{{facet.name}}{{facetResult.value}}">{{facetResult.displayValue}} ({{facetResult.count}})</label>
                  </li>
                </ul>
              </div>
              <a class="clearFilter" *ngIf="facet.results.length > 5" (click)="facet.isExpanded = !facet.isExpanded">Show {{facet.isExpanded ? 'Less' : 'More'}}</a>
            </div>
            <div *ngIf="isMobile">
              <div class="row mt-2">
                <div class="col-12 text-center">
                  <button class="btn-default btn mobileButton" mdbWavesEffect (click)="clearAllFacetFilters();expand=!expand">Clear All Filters</button>
                  <br />
                  <br />
                </div>
                <div class="col-12 text-center">
                  <button class="btn btn-primary mr-0 mobileButton" mdbWavesEffect (click)="applyMobile()">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div> 
      <div class="col-lg-9 col-md-12 jobsContainer" [class.hideGrid]="isMobile && expand">
        <div class="box">
        <div class="pb-0" *ngIf="isMobile">
          <div class="row">
            <div class="col-6 filterToggleCopntainer">
              <span class="filterToggle" (click)="expand=!expand"><i class="fa fa-bars"></i> Show Filters ({{facetFiltersCount}})</span>
            </div>
            <div class="col-6">
              <p class="resultsCount">{{jobTable.rowCount}} Results</p>            
            </div>
          </div> 
        </div>
        <div class="table-responsive">
            <div>
              <ngx-datatable class="jobsTable" #jobTable
                             [rows]="model.jobs.results"
                             [columnMode]="'flex'"
                             [headerHeight]="'auto'"
                             [footerHeight]="50"
                             [rowHeight]="'auto'"
                             [externalPaging]="true"
                             [count]="model.jobs.totalResults"
                             [offset]="model.jobs.pageNumber - 1"
                             [limit]="model.jobs.pageSize"
                             [loadingIndicator]="loading"
                             (page)="fetchData()"
                             [externalSorting]="true"
                             (sort)="fetchData()"
                             [sorts]="[{prop: 'postedDate', dir: 'desc'}]"
                             [messages]="{emptyMessage:'No matches found.'}">

                <!-- BEGIN MOBILE-ONLY -->
                <ngx-datatable-column [flexGrow]="3" [cellClass]="'pr-sm-4'" *ngIf="isMobile">
                  <ng-template let-job="row" ngx-datatable-cell-template>
                    <div class="row">
                      <div class="col-md-6 col-12 jobTitle">
                        <strong>Job Title</strong>
                        <a routerLink="/{{identifier}}{{getSubBrandPath(job)}}/jobs/{{job.id}}/{{slugify(job.title)}}">{{job.title}}</a>
                        <p>{{job.locationCityProvince}}</p>
                      </div>
                      <div class="col-md-3 col-12 jobDepartment">
                        <strong>Departments</strong>
                        <p>{{job.departmentName}}</p>
                      </div>
                      <div class="col-md-3 col-12 jobDate">
                        <strong>Posted Date</strong>
                        <p>{{job.displayPostedDate | customDateFormat}}</p>
                      </div>
                      <div *ngIf="model.displayApplicationDeadline" class="col-md-3 col-12 jobDate">
                        <strong>Application Deadline</strong>
                        <p>
                          {{job.applicationDeadline ? (job.applicationDeadline | applicationDeadline) : 'Open until filled'}}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- END MOBILE -->
                <!-- BEGIN NON-MOBILE -->
                <ng-container *ngIf="!isMobile">
                  <ngx-datatable-column name="Title" prop="title" [sortable]="true" [flexGrow]="3" [cellClass]="'pr-sm-4'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      <a class="jobLink" routerLink="/{{identifier}}{{getSubBrandPath(row)}}/jobs/{{row.id}}/{{slugify(row.title)}}">{{row.title}}</a>
                      <p><ng-container *ngIf="theme.filterConfiguration.useLocationNameFilter">{{row.locationName}} - </ng-container>{{row.locationCityProvince}}</p>
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column name="Department" prop="departmentName" [flexGrow]="1"></ngx-datatable-column>
                  <ngx-datatable-column name="Posted Date" [prop]="postedDateField" [sortable]="true" [flexGrow]="1" [headerClass]="'text-right'" [cellClass]="'text-right'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{row.displayPostedDate | customDateFormat}}
                    </ng-template>
                  </ngx-datatable-column>
                  <ngx-datatable-column *ngIf="model.displayApplicationDeadline" name="Deadline" [prop]="applicationDeadline" [sortable]="true" [flexGrow]="1" [headerClass]="'text-right'" [cellClass]="'text-right'">
                    <ng-template let-row="row" ngx-datatable-cell-template>
                      {{row.applicationDeadline ? (row.applicationDeadline | applicationDeadline) : 'Open until filled'}}
                    </ng-template>
                  </ngx-datatable-column>
                </ng-container>
                  <!-- END NON-MOBILE -->

                  <ngx-datatable-footer>
                    <ng-template ngx-datatable-footer-template>
                      <app-datatable-footer [table]="jobTable"
                                            (change)="jobTable.onFooterPage($event)">
                      </app-datatable-footer>
                    </ng-template>
                  </ngx-datatable-footer>
              </ngx-datatable>
            </div>
        </div>
      </div>
      </div>
    </div>
    <app-footer [theme]="theme" [class.hide]="isMobile && expand"></app-footer>
  </div>
</div>
